import { HStack, Box, Circle } from "@chakra-ui/react"

interface GameStepIndicatorProps {
  total: number
  current: number // 0-indexed
  onStepClick: (index: number) => void
}

export function GameStepIndicator({
  total,
  current,
  onStepClick,
}: GameStepIndicatorProps) {
  return (
    <HStack gap="0" justify="center" py="3">
      {Array.from({ length: total }, (_, i) => {
        const isPast = i < current
        const isCurrent = i === current
        const isFuture = i > current
        const clickable = isPast

        return (
          <HStack key={i} gap="0">
            {/* connector line (skip before the first dot) */}
            {i > 0 && (
              <Box
                w="6"
                h="2px"
                bg={i <= current ? "emerald.400" : "gray.200"}
                transition="background 0.2s"
              />
            )}

            {/* dot */}
            <Circle
              size="3.5"
              bg={
                isCurrent
                  ? "emerald.500"
                  : isPast
                    ? "emerald.500/50"
                    : "transparent"
              }
              borderWidth="2px"
              borderColor={
                isCurrent
                  ? "emerald.500"
                  : isPast
                    ? "emerald.400"
                    : "gray.300"
              }
              cursor={clickable ? "pointer" : isFuture ? "not-allowed" : "default"}
              transition="all 0.2s"
              _hover={clickable ? { transform: "scale(1.3)" } : undefined}
              onClick={() => {
                if (clickable) {
                  onStepClick(i)
                }
              }}
              aria-label={`Step ${i + 1}`}
            />
          </HStack>
        )
      })}
    </HStack>
  )
}
